import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPointUserList, createPointUser, updatePointUser, deletePointUser, getPointUserSubList, createPointUserSub, deletePointUserSub } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'PointRuleUserConfig',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getPointUserList,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      addSubDialogVisible: false,
      dialogTitle: '',
      stationOptions: [],
      tableDataSub: {
        tableData: [],
        page: 1,
        pageSize: 10,
        total: 0
      },
      selPointUser: {},
      selPointUserID: '',
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _this3.formData = _this3.initData();

                _this3.onSubmit();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        mobile: '',
        mobileSub: ''
      };
      return formdata;
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      if (this.searchInfo.mobileSub) {
        this.tableDataSub.page = 1;
        this.tableDataSub.pageSize = 10;
        this.getTableDataSub();
        return;
      }

      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
      this.tableDataSub.page = 1;
      this.tableDataSub.pageSize = 10;
      this.getTableDataSub();
      this.selPointUser = {};
      this.selPointUserID = '';
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.selPointUserID = row.ID;
      this.selPointUser = row;
      this.tableDataSub.page = 1;
      this.tableDataSub.pageSize = 10;
      this.getTableDataSub({
        mobile: row.mobile
      });
      this.$forceUpdate();
    },
    // 子用户列表
    getTableDataSub: function getTableDataSub(query) {
      var _this4 = this;

      var param = {};

      if (query) {
        param = query;
      } else {
        param = this.searchInfo;
      }

      getPointUserSubList(_objectSpread(_objectSpread({}, param), {}, {
        page: this.tableDataSub.page,
        pageSize: this.tableDataSub.pageSize
      })).then(function (res) {
        _this4.tableDataSub.tableData = res.data.list;
        _this4.tableDataSub.total = res.data.total;
        _this4.tableDataSub.page = res.data.page;
        _this4.tableDataSub.pageSize = res.data.pageSize;
      });
    },
    handleCurrentChangeSub: function handleCurrentChangeSub(val) {
      this.tableDataSub.page = val;
      this.getTableDataSub();
    },
    handleSizeChangeSub: function handleSizeChangeSub(val) {
      this.tableDataSub.pageSize = val;
      this.getTableDataSub();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增积分用户';
    },
    // 新增
    onUpateStatus: function onUpateStatus(mobile, status) {
      var _this5 = this;

      updatePointUser({
        'mobile': mobile,
        'status': status
      }).then(function (res) {
        _this5.getTableData();
      });
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deletePointUser({
          'mobile': row.mobile
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    // 新增子用户
    onAddSub: function onAddSub(row) {
      if (row) {
        this.formData.mobile = row.mobile;
      }

      this.type = 'addsub';
      this.addSubDialogVisible = true;
      this.dialogTitle = '新增子用户';
    },
    // 删除子用户
    onDeleteSub: function onDeleteSub(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deletePointUserSub({
          'mobile': row.mobile,
          'mobileSub': row.mobileSub
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.addSubDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'addsub':
          that.handleAddSub();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
        this.getTableDataSub();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this6;

                if (that.validFormData()) {
                  createPointUser(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增子用户保存
    handleAddSub: function handleAddSub() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this7;

                if (that.validFormDataSub()) {
                  createPointUserSub(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (that.formData.mobile == '' || that.formData.mobile.trim().length != 11) {
        that.$message({
          type: 'warning',
          message: '请输入积分用户手机'
        });
        return false;
      }

      return true;
    },
    // 公共校验函数
    validFormDataSub: function validFormDataSub() {
      var that = this;

      if (that.formData.mobile == '' || that.formData.mobile.trim().length != 11) {
        that.$message({
          type: 'warning',
          message: '请输入积分用户手机'
        });
        return false;
      }

      if (that.formData.mobileSub == '' || that.formData.mobileSub.trim().length != 11) {
        that.$message({
          type: 'warning',
          message: '请输入子用户手机'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      return this.formData;
    }
  }
};